<template>
    <div class="text-center text-xs text-gray-300">
        <slot />
    </div>
</template>
